import React, { useEffect } from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiGridForm from "../components/Form/UiGridForm";
import UiInputList from "../components/Form/UiInputList";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import { useNotification } from '../components/Core/NotificationProvider';

/**
 * O fornecedor é papel, e só isso: quem ele é (identificação, razão social, nome
 * fantasia, CNPJ, inscrição estadual, contato e endereço) mora no cadastro de
 * Pessoa, que este form referencia pelo suggest em vez de embutir. Pessoa que ainda
 * não existe se cadastra pela lupa do próprio suggest, que abre o grid de Pessoa
 * com o Adicionar.
 *
 * Ficam aqui o acesso à plataforma do fornecedor e as contas bancárias, que são do
 * papel e não da pessoa.
 */
export default function FornecedorForm(props: any){
    const methods = useForm({
        defaultValues: props.data
    });
    const { handleSubmit, reset } = methods;
    const notification = useNotification();

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    const tipoContaList = [
        { id: 1, title: 'Conta Corrente' },
        { id: 2, title: 'Poupança' }
    ];

    const salvar = (dados: any) => {
        if (!dados.pessoa?.id) {
            notification.error('Fornecedor precisa da pessoa');
            return;
        }

        props.triggerSubmit(dados);
    };

    return (
        <>
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(salvar)} methods={methods}>
                    <WindowBody>
                        <div className="row">
                            <div className="col-lg-12">
                                <fieldset>
                                    <legend>Fornecedor</legend>
                                    <div className="row">
                                        <UiInputSuggest size={12} name="pessoa" router="unpessoa" idField="id" titleField="nome" label="Pessoa"/>
                                    </div>
                                </fieldset>
                            </div>

                            <div className="col-lg-12">
                                <fieldset>
                                    <legend>Plataforma</legend>
                                    <div className="row">
                                        <UiInputText size={6} name="plataformaLink" label="Link"/>
                                        <UiInputText size={3} name="plataformaUsuario" label="Usuário" autoComplete="off"/>
                                        <UiInputText size={3} name="plataformaSenha" label="Senha" type="text" autoComplete="new-password"/>
                                    </div>
                                </fieldset>
                            </div>

                            {/* Contas Bancárias */}
                            <UiGridForm name="contaBancariaList" label="Contas Bancárias">
                                <UiInputText size={2} name="bancoCodigo" label="Código" />
                                <UiInputText size={3} name="bancoNome" label="Banco" />
                                <UiInputText size={2} name="agencia" label="Agência" />
                                <UiInputText size={2} name="conta" label="Conta" />
                                <UiInputList size={3} name="tipo" list={tipoContaList} idField="id" titleField="title" label="Tipo" />
                            </UiGridForm>
                        </div>
                    </WindowBody>

                    <WindowFooter>
                        <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                        <UiButton variant="primary" type="submit">Salvar</UiButton>
                    </WindowFooter>
                </Form>
            </FormProvider>
        </>
    )
}
